var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.828.276h494.345a8.829 8.829 0 0 1 8.828 8.828V168H0V9.103A8.828 8.828 0 0 1 8.828.276z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.172 335.724H8.828A8.829 8.829 0 0 1 0 326.896V168h512v158.897a8.828 8.828 0 0 1-8.828 8.827z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.256 333.59l244.341-160.086c3.966-2.599 3.966-8.412 0-11.009L3.256 2.41C1.311 4.029 0 6.375 0 9.103v317.793c0 2.729 1.311 5.075 3.256 6.694z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE15A",
    cx: 90.505,
    cy: 133.926,
    r: 27.719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.39 159.606c.11 3.363.476 6.833.829 10.187 1.385 13.163 2.582 24.533-10.06 28.943-2.988 1.042-7.06 1.626-10.996 2.19-5.651.81-10.711 1.534-13.654 3.585-2.943-2.05-8.002-2.775-13.654-3.585-3.936-.564-8.009-1.149-10.996-2.19-12.642-4.41-11.445-15.78-10.06-28.943.353-3.354.718-6.824.829-10.187.393-11.918-2.12-23.596-3.885-30.197 2.941 1.207 7.018 2.296 12.017 2.208 2.154-.043 4.573-.35 7.133-.674 5.844-.745 12.467-1.583 17.768.512l.85.378.85-.378c5.3-2.095 11.924-1.257 17.768-.512 2.56.324 4.979.631 7.133.674 4.999.088 9.077-1.002 12.017-2.208-1.77 6.6-4.282 18.279-3.889 30.197z",
    fill: "#8CD7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.007 159.453c-.557-16.894 5.207-33.843 5.266-34.012l-3.633-2.551c-.047.039-5.511 4.277-14.291 4.108-1.908-.036-4.207-.329-6.642-.639-6.113-.774-13.009-1.651-19.199.486-6.19-2.136-13.085-1.259-19.199-.486-2.434.309-4.734.602-6.642.639-8.78.169-14.243-4.07-14.291-4.108l-3.633 2.551c.057.169 5.823 17.118 5.266 34.012-.105 3.199-.461 6.583-.807 9.856-1.389 13.206-2.964 28.175 13.133 33.791 3.411 1.188 7.721 1.714 11.862 2.4 12.433 2.06 14.31 5.236 14.31 5.236s1.877-3.177 14.31-5.236c4.141-.686 8.451-1.212 11.862-2.4 16.098-5.615 14.524-20.585 13.133-33.791-.343-3.274-.7-6.657-.805-9.856zm-4.617.153c.11 3.363.476 6.833.829 10.187 1.385 13.163 2.582 24.533-10.06 28.943-2.988 1.042-7.06 1.626-10.996 2.19-5.651.81-10.711 1.534-13.654 3.585-2.943-2.05-8.002-2.775-13.654-3.585-3.936-.564-8.009-1.149-10.996-2.19-12.642-4.41-11.445-15.78-10.06-28.943.353-3.354.718-6.824.829-10.187.393-11.918-2.12-23.596-3.885-30.197 2.941 1.207 7.018 2.296 12.017 2.208 2.154-.043 4.573-.35 7.133-.674 5.844-.745 12.467-1.583 17.768.512l.85.378.85-.378c5.3-2.095 11.924-1.257 17.768-.512 2.56.324 4.979.631 7.133.674 4.999.088 9.077-1.002 12.017-2.208-1.77 6.6-4.282 18.279-3.889 30.197z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M114.33 188.004v-10.183h1.745v-3.003h-4.268v-10.457h4.268l-19.518-13.827v-5.201h2.715l-8.764-6.208-8.762 6.208h2.713v5.201l-19.518 13.827h4.269v10.457h-4.269v3.003h1.746v10.183h-2.55v4.395h52.744v-4.395z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#41AA5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.193 146.33c-.622 1.474-.516 3.036.145 4.185 1.286-.328 2.478-1.341 3.101-2.814.622-1.474.516-3.036-.145-4.185-1.285.328-2.478 1.341-3.101 2.814z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.216 146.794c.407 1.547 1.446 2.719 2.671 3.225.818-1.044 1.143-2.575.736-4.122-.407-1.547-1.446-2.719-2.671-3.225-.817 1.043-1.143 2.575-.736 4.122zm4.698-2.572c1.5.557 3.055.384 4.175-.328-.383-1.27-1.448-2.418-2.947-2.975-1.5-.557-3.055-.384-4.175.328.383 1.269 1.447 2.416 2.947 2.975z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.321 141.582c1.464-.644 2.461-1.852 2.769-3.142-1.16-.644-2.722-.727-4.186-.084-1.464.644-2.46 1.852-2.769 3.142 1.158.645 2.721.728 4.186.084zm-9.842 1.334c1.305-.926 2.038-2.308 2.081-3.635-1.265-.398-2.813-.165-4.118.76-1.305.925-2.038 2.308-2.081 3.635 1.265.399 2.814.166 4.118-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.389 140.983c2.008 1.15 4.159 1.462 5.759 1-.412-1.614-1.769-3.311-3.777-4.461-2.008-1.15-4.159-1.462-5.759-1 .412 1.614 1.77 3.311 3.777 4.461z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.86 143.341c0-.78-.621-1.408-1.395-1.437a1.44 1.44 0 0 0-1.437-1.395 1.44 1.44 0 0 0-1.437 1.395 1.44 1.44 0 0 0-1.395 1.437c0 .78.621 1.407 1.395 1.437a1.44 1.44 0 0 0 1.437 1.395 1.44 1.44 0 0 0 1.437-1.395 1.443 1.443 0 0 0 1.395-1.437z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F5F5",
    cx: 69.032,
    cy: 143.338,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.34 141.909c0-.642-.511-1.158-1.146-1.181a1.185 1.185 0 0 0-1.181-1.146c-.642 0-1.158.511-1.181 1.146a1.185 1.185 0 0 0-1.146 1.181c0 .642.511 1.158 1.146 1.181.024.636.54 1.146 1.181 1.146.642 0 1.158-.511 1.181-1.146a1.185 1.185 0 0 0 1.146-1.181z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F5F5",
    cx: 65.013,
    cy: 141.903,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.676 139.906a.855.855 0 0 0-.826-.851.854.854 0 0 0-.851-.826.854.854 0 0 0-.851.826.854.854 0 0 0-.826.851c0 .462.369.834.826.851a.854.854 0 0 0 .851.826.854.854 0 0 0 .851-.826.853.853 0 0 0 .826-.851z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F5F5",
    cx: 70.003,
    cy: 139.906,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.494 138.46a.855.855 0 0 0-.826-.851.854.854 0 0 0-.851-.826.855.855 0 0 0-.851.826.854.854 0 0 0-.826.851c0 .463.369.834.826.851a.854.854 0 0 0 .851.826.855.855 0 0 0 .851-.826.854.854 0 0 0 .826-.851z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 133)",
    fill: "#F5F5F5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.814,
    cy: 5.461,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.406 18.156h16.021a8.778 8.778 0 0 0-5.535-4.907c.182-1.166.294-2.461.294-3.85 0-4.839-1.239-8.761-2.769-8.761s-2.769 3.923-2.769 8.761c0 1.388.111 2.684.294 3.85a8.775 8.775 0 0 0-5.536 4.907z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.508 229.793c-33.754 0-61.216-27.46-61.216-61.216h11.55c0 27.386 22.28 49.665 49.665 49.665 27.385 0 49.665-22.279 49.665-49.665h11.552c0 33.756-27.46 61.216-61.216 61.216z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.196 113.879h-9.983a1.815 1.815 0 1 0 0-3.63H90.508a1.815 1.815 0 1 0 0 3.63H67.821a2.722 2.722 0 1 0 0 5.444h8.167a1.814 1.814 0 1 0 .001 3.63h16.335a1.815 1.815 0 0 0 .001-3.63h20.872a2.722 2.722 0 1 0-.001-5.444z",
    fill: "#C87878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSx);
export default __webpack_public_path__ + "static/media/sx.c2970bc4b70396232520d65c649f6adc.svg";
export { ForwardRef as ReactComponent };